import { Component } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService} from "primeng/api";
import {Impresa} from "../../../../models/impresa.model";
import {asNulledInt, asTrimNulledString, ensureObjectBreadCrumbValue, listToDict, readXlsxUploadAsTable, XlsxParsedSheet} from "../../../../lib/support";
import {MagazzinoApiDescriptor, ModelloDispositivoApiDescriptor} from "../../../../models/magazzino.model";

@Component({
  selector: 'app-movimentazioni-caricamento-dialog',
  templateUrl: './movimentazioni-caricamento-dialog.component.html',
  styleUrls: ['./movimentazioni-caricamento-dialog.component.scss']
})
export class MovimentazioniCaricamentoDialogComponent {

	dataReady:				boolean;
	validEdits: 			boolean;
	modeCreate:				boolean;

	innerDataFileReference: File[];
	dataFileRef: File;

	materialiByNmu: {[key: string]: ModelloDispositivoApiDescriptor};

	materialiById: {[key: string]: ModelloDispositivoApiDescriptor};
	magazziniById: {[key: string]: MagazzinoApiDescriptor};


	builder: {[key: string]: {
		[key: string]: {
			[key: string]: number
		}
	}};

	oplist: AllineamentoOperationRow[];

	constructor(
		public dialogService: DialogService,
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			imprese: Impresa[],
			magazzini: MagazzinoApiDescriptor[],
			materiali: ModelloDispositivoApiDescriptor[]
		}>,
		private messages: MessageService
	) {
		console.log("mov upload dialog w config ", this.config);

		this.onDataFileDeselected();

		this.materialiByNmu = listToDict(this.config.data.materiali, "nmu");
		this.materialiById = listToDict(this.config.data.materiali, "id");
		this.magazziniById = listToDict(this.config.data.magazzini, "id");
	}

	onDataFileDeselected () {
		this.dataFileRef = null;
		this.innerDataFileReference = [];
		this.builder = null;
		this.oplist = null;
	}

	onDataFileSelected(files: File[]) {
		if (files != null) {
			this.dataFileRef = files[0];
			this.innerDataFileReference = !!files[0] ? [files[0]] : [];
			console.log("file ref", this.dataFileRef);


		}

		this.reloadXlsxData();
	}

	reloadXlsxData () {

		if (this.dataFileRef != null) {

			readXlsxUploadAsTable(this.dataFileRef, (data) => {
				try {
					this.builder = this.sheetToBuilder(data.sheets[0]);
					this.rebuildOperationsList ();
				} catch (error) {
					this.messages.add({
						severity: "error",
						summary: "dati xlsx non validi",
						detail: error,
						sticky: true,
						styleClass: "message_debug_wide",
						closable: true
					});
					this.onDataFileDeselected();
				}
			});


		}
	}

	getMagazzinoImpresa (codmag: string, idImpresa: number) {
		let mags = this.config.data.magazzini.filter((item) => {
			return item.codice == codmag;
		});
		if (mags.length > 1) {
			mags = mags.filter((item) => {
				return item.azienda == idImpresa;
			});
		}
		return mags.length == 1 ? mags[0] : null;
	}

	rebuildOperationsList () {
		const rows: AllineamentoOperationRow[] = [];
		for (let opid in this.builder) {
			for (let magid in this.builder[opid]) {
				for (let [matid, matqt] of Object.entries(this.builder[opid][magid])) {
					console.log(matid, this.materialiById);
					rows.push({
						opid: opid,
						mag: this.magazziniById[magid],
						mat: this.materialiById[matid],
						qt: matqt
					});
				}
			}
		}

		console.log("ops", rows);
		this.oplist = rows;
	}

	sheetToBuilder (sheet: XlsxParsedSheet) {
		const by_op_mag_mat = {};
		for (let i = 0; i < sheet.values.length; i++) {
			const row = sheet.values[i];
			const operationid = asTrimNulledString(row["operazione_id"]);
			const impresaid = asNulledInt(row["impresa_id"]);
			const magid = asTrimNulledString(row["magazzino_codice"]);
			const nmuid = asTrimNulledString(row["nmu"]);
			const nmuqt = asNulledInt(row["qt"]);

			if ([operationid, magid, nmuid, nmuqt].every((value) => {return (value == null); })) {
				continue;
			}

			const mag = this.getMagazzinoImpresa(magid, impresaid);
			const mat = this.materialiByNmu[nmuid] ?? null;
			if ([mag, operationid, magid, mat, nmuqt].some((value) => {return (value == null); })) {
				console.warn("values error: ", row, [mag, operationid, magid, mat, nmuqt]);
				const values_str = JSON.stringify(row);
				throw `Invalid data at xlsx row ${(i+2)}: ${values_str}`;
			}

			ensureObjectBreadCrumbValue(by_op_mag_mat, 0, [operationid, mag.id, mat.id]);
			by_op_mag_mat[operationid][mag.id][mat.id] += nmuqt;

		}
		// console.log("builder", by_op_mag_mat);
		return by_op_mag_mat;



	}

	onActivityCompleted (confirm: boolean) {
		this.ref.close(confirm ? this.builder : null);
	}

}


interface AllineamentoOperationRow {
	opid:					string;
	mag:					MagazzinoApiDescriptor;
	mat:					ModelloDispositivoApiDescriptor;
	qt:						number;
}